module.exports = __webpack_public_path__ + "assets/img/warrior-name-85d45ad3.png";